import Vue from 'vue'
import App from './App.vue'

// Custom styles
import "@/assets/css/main.css"
import "@/assets/css/colors.css"

// Font awesome icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle, faFolderOpen, faLongArrowAltDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCircle, faFolderOpen, faLongArrowAltDown)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Scroll
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll);
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

//  Tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip);

// Scrollbar
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
Vue.use(PerfectScrollbar)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
